import { useAuth } from "../context/AuthContext";

export const USER_ROLES = {
  OFFICER: "officer",
  RECORDS: "records",
} as const;

export type UserRole = typeof USER_ROLES[keyof typeof USER_ROLES];

export const useUserRoles = () => {
  const { user } = useAuth();
  
  const hasRole = (role: UserRole): boolean => {
    if (!user?.roles) return false;
    return user.roles.includes(role);
  };

  const isOfficer = (): boolean => hasRole(USER_ROLES.OFFICER);
  const isRecords = (): boolean => hasRole(USER_ROLES.RECORDS);

  const hasAnyRole = (roles: UserRole[]): boolean => {
    if (!user?.roles) return false;
    return roles.some(role => user.roles!.includes(role));
  };

  return {
    userRoles: user?.roles || [],
    hasRole,
    isOfficer,
    isRecords,
    hasAnyRole,
  };
};